/**
 * @type {function(this: import("flightjs").ComponentAPI<
 * {
 *   tooltip: string,
 *   tooltipDismissEvent: string,
 * },
 * {
 *   enableTooltips: Function,
 * },
 * >): void}
 */
export default function() {
    this.attributes({
        tooltip: '[data-tooltip]',
        tooltipDismissEvent: 'uiDismissTooltip',
    });

    this.after('initialize', function() {
        this.enableTooltips();
    });

    this.enableTooltips = function() {
        this.select('tooltip').tooltip();

        this.select('tooltip').on(this.attr.tooltipDismissEvent, function() {
            $(this)
                .data('tooltip')
                .hide();
        });
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/mixins/with-tooltips.js